$('header #header-basket-button').on('click', (e) => {
	e.preventDefault();

	window.dispatchEvent(new CustomEvent('toggleBasketSidebar'))
})
$('.header-mobile #header-basket-button').on('click', (e) => {
	e.preventDefault();

	window.dispatchEvent(new CustomEvent('toggleBasketSidebar'))
})

let wishlistItems = window.localStorage.getItem('wishlist')
	? JSON.parse(window.localStorage.getItem('wishlist'))
	: [];

if (wishlistItems.length) {
	$('#header-wishlist-button').append(`<span>${wishlistItems.length}</span>`)
}

$('.faq-list-item-title').on('click', function () {
	$(this).next().stop().slideToggle();
})

new Swiper('.blog-list-slider', {
	loop: true,
	spaceBetween: 15,
	autoplay: {
		delay: 5000,
	},
	navigation: {
		nextEl: '.blog-list-slider .swiper-button-next',
		prevEl: '.blog-list-slider .swiper-button-prev',
	},
	breakpoints: {
		320: { slidesPerView: 1 },
		768: { slidesPerView: 2 },
		992: { slidesPerView: 3 },
		1200: { slidesPerView: 3 },
	},
});

// To Price Function
function toPrice(price) {
	return (price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function getPercentageChange(oldNumber, newNumber){
	var decreaseValue = oldNumber - newNumber;

	return ((decreaseValue / oldNumber) * 100).toFixed(0);
}

if (window.location.href.includes('?contact%5Btags%5D=newsletter&form_type=customer')) {
	$('html, body').scrollTop($('.email-subscription').offset().top);
	
	$('.email-subscription .error').css('display', 'block');
}else {
	$('.email-subscription .error').css('display', 'none');
}

$('.gallery-item').on('click', function () {
	const arr = []
	
	$(this).find('.gallery-item-image').map(function () {
		if ($(this).data('product-title')) {
			arr.push(`
				<a href="/products/${$(this).data('product-handle')}" target="_blank">
					<div>${$(this).data('product-title')} Product</div>
					<img src="https:${$(this).find('img').attr('src')}" alt="" />
				</a>
			`);
		} else {
			arr.push(`<img src="https:${$(this).find('img').attr('src')}" alt="" />`);
		}
	});
	
	$('.gallery-modal-contain-body-images').html(arr.join(''));

	$('body').css('overflow', 'hidden');
	$('.gallery-modal').addClass('show');
	$('.gallery-modal-contain').scrollTop(0)
	$('.gallery-modal-contain-body > a').attr('href', $(this).data('url'))
	$('.gallery-modal').attr('data-index', $(this).parent().index())
});

$('.gallery-modal-filter, .gallery-modal-close button').on('click', function () {
	$('body').css('overflow', 'visible');
	$('.gallery-modal').removeClass('show');
});

$('.gallery-modal-arrows button').on('click', function () {
	const modal = $('.gallery-modal');
	const index = parseInt(modal.attr('data-index'))

	if ($(this).hasClass('prev')) {
		if (index === 0) {
			$(`.tab-pane.active .col-lg-4:nth-child(${$('.tab-pane.active .col-lg-4').length})`).find('.gallery-item').click();
		} else {
			$(`.tab-pane.active .col-lg-4:nth-child(${index})`).find('.gallery-item').click();
		}
	}

	if ($(this).hasClass('next')) {
		if (index === $('.tab-pane.active .col-lg-4').length - 1) {
			$('.tab-pane.active .col-lg-4:nth-child(1)').find('.gallery-item').click();
		} else {
			$(`.tab-pane.active .col-lg-4:nth-child(${index + 2})`).find('.gallery-item').click();
		}
	}
})

$('.item-quantity-input #minus').on('click', function () {
	if ($(this).next().val() > 1) {
		$(this).next().val($(this).next().val() - 1);
		setTimeout(() => {
			$('input[name="update"]').click();
		}, 200)
	}
})

$('.item-quantity-input #plus').on('click', function () {
	$(this).prev().val(parseInt($(this).prev().val()) + 1);
	setTimeout(() => {
		$('input[name="update"]').click();
	}, 200)
})

if ($('.wishlist-items').length) {
	const items = window.localStorage.getItem('wishlist') ? JSON.parse(window.localStorage.getItem('wishlist')) : [];

	if (items.length === 0) {
		$('p.loading').remove();
		$('.wishlist-items').append('<p>No items found.</p>');
	} else {
		$('p.loading').remove();

		items.map((item) => {
			$('.wishlist-items').append(`
				<div class="item" data-id="${item.id}">
					<div class="item-left">
						<img src="${item.featured_image}" alt="">
		
						<h5>${item.title}</h5>
					</div>
		
					<div class="item-right">
						<a href="/products/${item.handle}">View product</a>
						<button>Remove</button>
					</div>
				</div>
			`);
		});
	}

	$('body').on('click', function (e) {
		if ($(e.target).parent().hasClass('item-right')) {
			const find = items.filter((item) => {
				return item.id !== $(e.target).parent().parent().data('id');
			});

			window.localStorage.setItem('wishlist', JSON.stringify(find));

			$(e.target).parent().parent().hide();
		}
	});
}

let timeout;

$('.search-input-wrapper input[name="q"]').on('keyup', function (e) {
	const container = $(this).parent().parent().parent().find('.search-list')

	clearTimeout(timeout)

	if ($(this).val() === '' || e.code === 'Escape') {
		container.hide()
	} else {
		container.show()

		container.html('')
	
		container.append('<p>loading...</p>')
	
		timeout = setTimeout(() => {
			fetch(`/search/suggest.json?q=${$(this).val()}&resources[type]=product,article&resources[options][fields]=title,product_type,variants.title`)
				.then((response) => response.json())
				.then((suggestions) => suggestions.resources.results)
				.then(response => {
					const products = response.products
					const articles = response.articles

					let productsHTML = ''
					let articlesHTML = ''

					const filteredProducts = products.filter(product => !product.tags.includes('Sub Product'))
	
					filteredProducts.map(product => {
						productsHTML += `<li><a href="${product.url}">${product.title}</a></li>`
					})

					articles.map(article => {
						articlesHTML += `<li><a href="${article.url}">${article.title}</a></li>`
					})
	
					container.html('')
	
					container.append(`
						<p style="text-align: left;margin: 0 15px 5px 15px;font-size: 16px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding: 5px 0 5px 0;">Products</p>
						<ul style="margin-bottom: 10px">${productsHTML}</ul>

						<p style="text-align: left;margin: 0 15px 5px 15px;font-size: 16px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding: 5px 0 5px 0;">Blog posts</p>
						<ul>${articlesHTML}</ul>
					`)
				})
		}, 1000)
	}
})

// Mobile Header
if (window.innerWidth <= 768) {
	var lastScrollTop = 0;
	var threshold = 100;

	$('#main-content').css('opacity', '1')

	window.addEventListener('scroll', function (e) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if (st < threshold) {
			$('.visit-showroom-message').show();
		}

		if ((Math.abs(st - lastScrollTop) >= threshold)) {
			if (st > lastScrollTop) {
				$('.header-mobile .header-mobile-search-input').hide();
				$('.header-mobile .header-mobile-contact').hide();
			} else if (st < lastScrollTop) {
				$('.header-mobile .header-mobile-search-input').show();
				$('.header-mobile .header-mobile-contact').show();
			}

			if (lastScrollTop >= 100 && st > lastScrollTop) {
				$('.visit-showroom-message').hide();
			}
		
			lastScrollTop = st <= 0 ? 0 : st;
		}
	})
} else {
	$('#main-content').css('opacity', '1')
	$('#main-content').css('padding-top', $('.header-outer').height() + 'px')

	$(window).on('resize', function () {
		$('#main-content').css('padding-top', $('.header-outer').height() + 'px')
	})
}

$('.header-mobile-menu .toggle-menu button').on('click', function () {
	$('.header-mobile-big-navigation').fadeIn(200)

	document.body.style.overflow = 'hidden';
	
	$('#dynamic-react-root + div > .needsclick').hide();
	$('#shopify-chat').hide();
})

$('.header-mobile-big-navigation-close button').on('click', function () {
	$('.header-mobile-big-navigation').fadeOut(200)

	document.body.style.overflow = 'auto';

	$('#dynamic-react-root + div > .needsclick').show();
	$('#shopify-chat').show();
})

$('.header-mobile-big-navigation-list > ul > li > button').on('click', function () {
	$(this).toggleClass('active')
	$(this).next().slideToggle(500)
})
